import { call, put, select } from 'redux-saga/effects';
import { getCQPrices as getCQPricesAda } from '@bitComponents/adabyron/cqv2';
import { WEB_SERVICES } from './webServices';


const contextStore = state => state.context.data;

export function* getCQPrices(params) {
  const {
    reduxUpdate,
    cqId,
    chosenActions,
    normalizeHttpErrors,
  } = params;
  try {
    const context = yield select(contextStore);
    const { successUpdate } = reduxUpdate;
    const args = {
      cqId,
    };
    if (Array.isArray(chosenActions)) {
      args.chosenActions = chosenActions;
    }
    const response = yield call(getCQPricesAda, args, context);

    if (successUpdate) {
      yield put(successUpdate(response));
    }

    return response;
  } catch (error) {
    const { errorUpdate } = reduxUpdate;
    const errorNormalized = yield call(normalizeHttpErrors, WEB_SERVICES.GET_CQ_PRICES, error);
    if (errorUpdate) {
      yield put(errorUpdate(errorNormalized));
    }

    throw error;
  }
}
